import {
  BuildingReportOUT,
  ColumnSourceEnum,
  DynamicColumnOUT,
  dynamicMappingEditorFp,
  ExportResultOUT,
  ExportStatusEnum,
  inventoryAPi,
  MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum,
  mappingEditorDynamicColumnsFp,
  ObjectListIN,
  PropertyBrowserTreeNode,
  reportExportsApi,
} from "api-client";
import { dynamicTableStore } from "features/DynamicTable/DynamicTableStore";
import { makeAutoObservable } from "mobx";
import { buildingStore } from "store/Building/BuildingStore";

class InventoryStore {
  async fetchObjectsList(props: ObjectListIN, page: number, pageSize: number) {
    const buildinID = buildingStore.buildingID;
    if (!buildinID) return;

    const result = await inventoryAPi()
      .mappingEditorApiV1RoutersInventoryGetInventoryData(
        buildinID,
        props,
        page,
        pageSize
      )
      .then((response) => response.data)
      .catch((error) => {
        dynamicTableStore.setErrorFetchingObjects(true);
        console.error("error.GetInventoryData", error);
      });

    return result;
  }

  async triggerExport(props: ObjectListIN): Promise<ExportResultOUT | void> {
    if (!buildingStore.buildingID) return;
    return await inventoryAPi()
      .mappingEditorApiV1RoutersInventoryExportInventoryData(
        buildingStore.buildingID,
        props
      )
      .then((response) => response.data)
      .catch((error) => console.error("error.triggerInventoryExport", error));
  }

  async checkReport(
    report_id: string,
    tries = 3,
    waiting_time = 3000
  ): Promise<BuildingReportOUT | void> {
    if (!buildingStore.buildingID) return;

    for (let i = 0; i < tries; i++) {
      const response = await reportExportsApi()
        .reportApiV1RoutersExportsGetExportStatus(report_id)
        .then((response) => response.data)
        .catch((error) => console.error("error.checkReport", error));

      if (
        response &&
        (response.status === ExportStatusEnum.Done ||
          response.status === ExportStatusEnum.Failed)
      ) {
        return response;
      }

      if (i < tries - 1) {
        await new Promise((resolve) => setTimeout(resolve, waiting_time));
      }
    }
  }

  async fetchColumnSuggestions(property: PropertyBrowserTreeNode) {
    const buildingID = buildingStore.buildingID;
    if (!buildingID) return;
    return await dynamicMappingEditorFp()
      .mappingEditorApiV1RoutersIndexFilterRetrieveColumnSuggestionsForBuilding(
        buildingID,
        {
          column_key: property.column_key,
          column_source: property.column_source as ColumnSourceEnum,
        }
      )
      .then((response) => response.data)
      .catch((error) =>
        console.error("error.RetrieveColumnSuggestions", error)
      );
  }

  async fetchColumns(): Promise<DynamicColumnOUT[] | void> {
    if (!buildingStore.buildingID) return;
    return await mappingEditorDynamicColumnsFp()
      .mappingEditorApiV1RoutersDynamicColumnsGetDynamicColumns(
        undefined,
        buildingStore.buildingID,
        MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum.Inventory
      )
      .then((response) => response.data)
      .catch((error) => console.error("error.GetDynamicColumns", error));
  }

  async refreshTableObjects() {
    await dynamicTableStore.fetchObjectsList(0, true);
  }

  async getProperties() {
    if (!buildingStore.buildingID) return;
    return await dynamicMappingEditorFp()
      .mappingEditorApiV1RoutersIndexFilterPropertyBrowserBuilding(
        buildingStore.buildingID,
        MappingEditorApiV1RoutersIndexFilterPropertyBrowserBuildingViewNameEnum.Inventory
      )
      .then((response) => response.data)
      .catch((error) =>
        console.error("error.FilterPropertyBrowserFull", error)
      );
  }

  constructor() {
    makeAutoObservable(this);
  }

  static instance: InventoryStore;

  static getInstance(): InventoryStore {
    if (!InventoryStore.instance) {
      InventoryStore.instance = new InventoryStore();
    }
    return InventoryStore.instance;
  }
}

export const inventoryStore = InventoryStore.getInstance();
